export const MODAL_CONTENT = {
  HEADER: 'As promised, your credit score has improved! \uD83C\uDF89',
  DESCRIPTION: 'Tell a friend about StellarFi’s score increase guarantee and you’ll get a $5 credit when they sign up.'
}
